import { memo } from 'react';
import Box from '@mui/material/Box';
import { IJob } from '~/utils/interface/job';

type ClientInfomationProps = {
  data: IJob | undefined;
};

function ClientInformation(props: ClientInfomationProps) {
  const { data } = props;
  return (
    <Box className='p-5'>
      <Box className='text-[13px] font-[600]'>{data?.customer?.name}</Box>
      <Box className='text-[13px]'> {data?.customer?.phone}</Box>
      <Box className='text-[13px]'> {data?.customer?.address}</Box>
    </Box>
  );
}

export default memo(ClientInformation);
